"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { House, ShieldCheck, BatteryCharging, Wrench, Lightbulb, ClipboardCheck, ArrowRight } from "lucide-react";
const services = [{
  title: "01 BUON GOVERNO",
  description: "Ascolto e partecipazione dei cittadini: Più strumenti di partecipazione. Trasparenza e legalità: Amministrazione chiara e Bilancio Partecipato. Amministrazione efficiente: Servizi digitali rapidi.",
  icon: House,
  href: "#",
  color: "bg-emerald-600"
}, {
  title: "02 LAVORO E SVILUPPO",
  description: "Patto per il commercio: Sostegno ai negozi di vicinato. Sostegno alle imprese: Riorganizzazione Ufficio Europa. Nuove opportunità: Formazione e sportello lavoro.",
  icon: ShieldCheck,
  href: "#",
  color: "bg-blue-600"
}, {
  title: "03 MOBILITÀ E TRASPORTI",
  description: "Trasporto pubblico: Più corse tra centro e frazioni. Parcheggi e viabilità: Nuovi parcheggi di scambio. Mobilità sostenibile: Percorsi ciclabili e incentivi green.",
  icon: BatteryCharging,
  href: "#",
  color: "bg-orange-500"
}, {
  title: "04 AMBIENTE E SOSTENIBILITÀ",
  description: "Tutela del territorio: Consumo suolo zero. No inceneritore: Controllo degli inquinanti. Raccolta e riciclo: Riduzione rifiuti e tariffe eque.",
  icon: Wrench,
  href: "#",
  color: "bg-green-700"
}, {
  title: "05 SOCIALE E INCLUSIONE",
  description: "Sostegno alle famiglie: Centro per la famiglia. Fragilità al centro: Assistenza domiciliare. Pari opportunità: Inclusione lavorativa e sociale.",
  icon: Lightbulb,
  href: "#",
  color: "bg-rose-600"
}, {
  title: "06 GIOVANI E FUTURO",
  description: "Scuola di qualità: Edifici sicuri e moderni. Spazi cultura e sport: Impianti accessibili. Partecipazione: Valorizzazione Consiglio Giovani.",
  icon: ClipboardCheck,
  href: "#",
  color: "bg-purple-600"
}, {
  title: "07 CULTURA E TURISMO",
  description: "Patrimonio storico: Recupero siti archeologici. Eventi tutto l'anno: Festival locali. Biblioteche vive: Servizi moderni e sale studio.",
  icon: House,
  href: "#",
  color: "bg-amber-600"
}, {
  title: "08 SICUREZZA E LEGALITÀ",
  description: "Polizia locale: Nuove assunzioni e presenza. Prevenzione: Videosorveglianza e illuminazione. Educazione: Progetti di legalità nelle scuole.",
  icon: ShieldCheck,
  href: "#",
  color: "bg-slate-700"
}, {
  title: "09 DECORO URBANO",
  description: "Gestione verde: Manutenzione costante. Strade sicure: Interventi programmati. Quartieri curati: Riqualificazione partecipata.",
  icon: BatteryCharging,
  href: "#",
  color: "bg-teal-600"
}, {
  title: "10 TRANSIZIONE ECOLOGICA",
  description: "Energie rinnovabili: Piano Energetico Comunale. Basse emissioni: Mobilità elettrica. Recupero acque: Irrigazione aree pubbliche.",
  icon: Wrench,
  href: "#",
  color: "bg-cyan-600"
}, {
  title: "11 DIRITTI E COMUNITÀ",
  description: "Diritti e cittadinanza: Tutela per tutti. Volontariato: Coprogettazione territoriale. Comunità solidale: Servizi per chi è in difficoltà.",
  icon: Lightbulb,
  href: "#",
  color: "bg-indigo-600"
}, {
  title: "12 INVESTIMENTI STRATEGICI",
  description: "Cimitero monumentale: Nuovo progetto. Campo Pio XII: Recupero aree dismesse. Area mercatale: Multipiano Collodi.",
  icon: ClipboardCheck,
  href: "#",
  color: "bg-red-700"
}];
export default function ServicesGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="241985" id="electoralprogramgrid" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Il Nostro Programma per la Città
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Dodici punti concreti per costruire insieme il futuro della nostra comunità, basati su trasparenza, sostenibilità e inclusione.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} data-index={index} className="h-full">
                <Card className="bg-card text-card-foreground border border-border rounded-2xl hover:shadow-xl hover:-translate-y-1 transition-all duration-300 h-full flex flex-col shadow-sm overflow-hidden group">
                  <CardHeader className="pb-4">
                    <div className={`w-14 h-14 rounded-full ${service.color} flex items-center justify-center mb-4 shadow-md transition-transform group-hover:scale-110`}>
                      <span className="text-white font-bold font-default text-lg">
                        {service.title.substring(0, 2)}
                      </span>
                    </div>
                    <CardTitle className="text-xl font-bold font-default text-foreground">
                      {service.title.substring(3)}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow pb-6">
                    <p className="text-muted-foreground text-sm md:text-base leading-relaxed font-default">
                      {service.description}
                    </p>
                  </CardContent>
                  <CardFooter className="pt-0 mt-auto flex justify-end">
                    <div className="p-2 rounded-lg bg-accent/50">
                      <Icon className="w-5 h-5 text-primary opacity-40" />
                    </div>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-16 flex justify-center">
          <Button asChild size="lg" className="font-bold text-lg px-8 py-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
            <Link to="https://in-oarfish-1.10web.cloud/wp-content/uploads/2026/05/albano-conta-1.pdf" newTab>
              Scarica il programma integrale
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}